module.exports = __webpack_public_path__ + "files/5015ea5f6f9009466513c81e7b1b48f1.png";